(ns pfo.admin.controller
  (:require-macros [pfo.macros :refer [defcontroller]])
  (:require
   [pfo.api :as api  :refer [process-error]]
   [promesa.core :as p]
   [ajax.core]
   [ajax.formats :refer [raw-response-format text-response-format]]
   [pfo.admin.model :as model]
   [pfo.task.model :as task-model]
   [pfo.util :as util]
   [pfo.widget.progressbar :as progressbar]
   [keechma.next.controller :as ctrl]))

(derive :template-users :keechma/controller)
(defmethod ctrl/handle :template-users
  [{:keys [state*] :as ctrl} event {:keys [template-ids subscriber-id group-id]}]
  (case event
    :load (->> (model/templateuser-list template-ids subscriber-id group-id)
               (p/map
                (fn [templateusers]
                  (ctrl/transact ctrl
                                 (fn [& args] (reset!
                                               state*
                                               (into {} (map (fn [tu] [(:task_template_id tu) (:user_id tu)])) templateusers))))))
               (process-error))
    nil))

(derive :template-user-choices :keechma/controller)
(defmethod ctrl/handle :template-user-choices
  [{:keys [state*] :as ctrl} event {:keys [collection-id subscriber-id compliance]}]
  (case event
    :load (->> (if collection-id
                 (model/group-admin-permitted-users (if compliance
                                                      {:compliance_assign true}
                                                      {:task_assign true})
                                                    collection-id)
                 (model/subscriber-families-common-permitted-users (if compliance
                                                                     {:compliance-assign true}
                                                                     {:task-assign true})
                                                                   subscriber-id))
               (p/map
                (fn [users]
                  (ctrl/transact ctrl #(reset! state* users))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :aark-usage-report :keechma/controller)
(defmethod ctrl/handle :aark-usage-report
  [{:keys [state*] :as ctrl} event arg]
  (case event
    :load (let [{:keys [subscriber-id family-id year month non-zero family-breakdown order page]} arg]
            (->> (api/ajaxp (str "/licenseadmin/aark-usage/?"
                                 (util/make-params
                                  (util/remove-nil-values
                                   {:subscriber_id subscriber-id
                                    :family_id family-id
                                    :year year
                                    :month month
                                    :non_zero non-zero
                                    :family_breakdown family-breakdown
                                    :order order
                                    :page page}))) {})
                 (p/map (fn [response]
                          (ctrl/transact ctrl #(reset! state* response))))
                 (process-error)))
    :clear (reset! state* nil)
    nil))

(defn- load-into-state
  "GET URL with the non-nil PARAMS as query string into the controller state."
  [{:keys [state*] :as ctrl} url params]
  (->> (api/ajaxp (str url "?" (util/make-params (util/remove-nil-values params))) {})
       (p/map (fn [response] (ctrl/transact ctrl #(reset! state* response))))
       (process-error)))

(derive :aark-feedback-report :keechma/controller)
(defmethod ctrl/handle :aark-feedback-report
  [{:keys [state*] :as ctrl} event {:keys [subscriber-id family-id time-range timezone order page]}]
  (case event
    :load (load-into-state ctrl "/licenseadmin/aark-feedback/"
                           {:subscriber_id subscriber-id :family_id family-id
                            :time_range time-range :timezone timezone :order order :page page})
    :clear (reset! state* nil)
    nil))

(derive :aark-feedback-filters :keechma/controller)
(defmethod ctrl/handle :aark-feedback-filters
  [{:keys [state*] :as ctrl} event {:keys [subscriber-id]}]
  (case event
    :load (load-into-state ctrl "/licenseadmin/aark-feedback/filters" {:subscriber_id subscriber-id})
    :clear (reset! state* nil)
    nil))

(derive :aark-usage-filters :keechma/controller)
(defmethod ctrl/handle :aark-usage-filters
  [{:keys [state*] :as ctrl} event arg]
  (case event
    :load (let [{:keys [subscriber-id family-id year month]} arg]
            (->> (api/ajaxp (str "/licenseadmin/aark-usage/filters?"
                                 (util/make-params
                                  (util/remove-nil-values
                                   {:subscriber_id subscriber-id
                                    :family_id family-id
                                    :year year
                                    :month month}))) {})
                 (p/map (fn [response]
                          (ctrl/transact ctrl #(reset! state* response))))
                 (process-error)))
    :clear (reset! state* nil)
    nil))

(derive :automation-transactions :keechma/controller)
(defmethod ctrl/handle :automation-transactions
  [{:keys [state*] :as ctrl} event {:keys [family-id page order]}]
  (case event
    :load (->> (model/automation-transaction-list family-id page order)
               (p/map
                (fn [txs]
                  (ctrl/transact ctrl #(reset! state* txs))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :automation-transaction :keechma/controller)
(defmethod ctrl/handle :automation-transaction
  [{:keys [state*] :as ctrl} event {:keys [transaction-id]}]
  (case event
    :load (->>
           (api/ajaxp (str "/automation/transaction/" transaction-id "/") {})
           (p/map
            (fn [tx]
              (ctrl/transact ctrl #(reset! state* tx))))
           (process-error))
    :clear (reset! state* nil)
    nil))

(derive :automation-transaction-documents :keechma/controller)
(defmethod ctrl/handle :automation-transaction-documents
  [{:keys [state*] :as ctrl} event {:keys [transaction-id page order]}]
  (case event
    :load (->> (model/automation-transaction-document-list transaction-id page order)
               (p/map
                (fn [txs]
                  (ctrl/transact ctrl #(reset! state* txs))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :automation-dispositions :keechma/controller)
(defmethod ctrl/handle :automation-dispositions
  [{:keys [state*] :as ctrl} event {:keys [family-id page order assignments uid collection-name label-ids]
                                    :as params}]
  (case event
    :load  (->> (model/automation-disposition-list family-id page order (:include-related-objects params) assignments uid collection-name label-ids)
                (p/map
                 (fn [objects]
                   (ctrl/transact ctrl #(reset! state* objects))))
                (process-error))
    :clear (reset! state* nil)
    :assign-label (->> (api/ajaxp "/automation/disposition/"
                                  {:method :patch
                                   :params (util/remove-nil-values
                                            {:family_id family-id
                                             :disposition_id (:disposition-ids params)
                                             :label_id (:label-id params)
                                             :label_name (:label-name params)})})
                       (p/map (fn [response] (some-> (:on-success params) (apply [response]))))
                       (process-error (:errors params)))
    nil))

(derive :rule-list :keechma/controller)
(defmethod ctrl/handle :rule-list
  [{:keys [state*] :as ctrl} event {:keys []}]
  (case event
    :load (->> (task-model/rule-list)
               (p/map
                (fn [objects]
                  (ctrl/transact ctrl #(reset! state* objects))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :collection-template-list :keechma/controller)
(defmethod ctrl/handle :collection-template-list
  [{:keys [state*] :as ctrl} event {:keys []}]
  (case event
    :load  (->> (model/collection-template-list)
                (p/map
                 (fn [objects]
                   (ctrl/transact ctrl #(reset! state* objects))))
                (process-error))
    :clear (reset! state* nil)
    nil))

(derive :coltact :keechma/controller)
(defmethod ctrl/handle :coltact
  [{:keys [state*] :as ctrl} event arg]
  (case event
    :save  (let [[{:keys [errors on-success]} contact-id collection-id] arg]
             (->>
              (api/ajaxp (str "/coltact/contact/" contact-id "/")
                         {:params (util/remove-nil-values {:collection_id collection-id})
                          :method :post})
              (p/map (fn [response] (some-> on-success (apply [response]))))
              (process-error errors)))
    :get  (let [[{:keys [errors on-success on-error]} contact-id] arg]
            (->>
             (api/ajaxp (str "/coltact/contact/" contact-id "/") {:method :get})
             (p/map (fn [response] (some-> on-success (apply [response]))))
             (p/error (fn [err] (if on-error (on-error err) (throw err))))
             (process-error errors)))

    :clear (reset! state* nil)
    nil))

(defn load-countries [{:keys [state*] :as ctrl} event {:keys [scope]}]
  (case event
    :load (->> (model/countries scope)
               (p/map
                (fn [objects]
                  (ctrl/transact ctrl #(reset! state* objects))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :countries :keechma/controller)
(defmethod ctrl/handle :countries
  [ctrl event args]
  (load-countries ctrl event args))

(derive :id-countries :keechma/controller)
(defmethod ctrl/handle :id-countries
  [ctrl event args]
  (load-countries ctrl event args))

(derive :dropbox-sign-usage-report :keechma/controller)
(defmethod ctrl/handle :dropbox-sign-usage-report
  [{:keys [state*] :as ctrl} event arg]
  (case event
    :load  (let [[{:keys [errors on-success]} year month status non-zero csv] arg]
             (->>
              (api/ajaxp (str "/signature/report/")
                         (merge
                          {:params {:year year :month month :status status :non_zero non-zero :csv csv}}
                          (when csv {:response-format (ajax.core/ring-response-format {:format (text-response-format)})
                                     :response-with-headers true})))
              (p/map (fn [response]
                       (if on-success
                         (on-success response)
                         (ctrl/transact ctrl #(reset! state* response)))))
              (process-error errors)))
    :clear (reset! state* nil)
    nil))

(derive :whitelabels :keechma/controller)
(defmethod ctrl/handle :whitelabels
  [{:keys [state*] :as ctrl} event _params]
  (case event
    :load (->>
           (api/ajaxp "/licenseadmin/whitelabels/" {})
           (p/map
            (fn [whitelabels]
              (ctrl/transact ctrl #(reset! state* whitelabels))))
           (process-error))
    :clear (reset! state* nil)
    nil))

(defcontroller global-setting
  [{:keys [state*] :as ctrl} event {:keys [stype key value]}]
  (case event
    :list (->>
           (api/ajaxp "/licenseadmin/setting/" {:params {:stype stype}})
           (p/map (fn [response]
                    (ctrl/transact ctrl #(reset! state* response))))
           (process-error))
    :update (->>
             (api/ajaxp "/licenseadmin/setting/" {:params {:stype stype
                                                           :key key
                                                           :value value}
                                                  :method :post})
             (process-error))
    :clear (reset! state* nil)
    nil))


(derive :token-usage :keechma/controller)
(defmethod ctrl/handle :token-usage
  [{:keys [state*] :as ctrl} event {:keys [subscriber-id family-id time-range timezone order on-success on-error errors-atom]}]
  (case event
    :load (->> (api/ajaxp (str "/chat/token_usage?" (util/make-params
                                                      (util/remove-nil-values
                                                       {:subscriber_id subscriber-id
                                                        :family_id family-id
                                                        :time_range time-range
                                                        :timezone timezone
                                                        :order order}))) {})
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :clear (reset! state* nil)
    nil))

(derive :family-delete :keechma/controller)
(defmethod ctrl/handle :family-delete
  [{:keys [state*] :as ctrl} event {:keys [family-id errors on-success]}]
  (case event
    :load-preview (do 
                    (ctrl/transact ctrl #(reset! state* {:stage :loading}))
                    (process-error errors
                                   (-> (api/ajaxp (str "/licenseadmin/group/" family-id "/delete-progress-token/") {:disable-loadin-counter true})
                                       (p/then (fn [{:keys [token]}]
                                                 (progressbar/start-progress-listener "/licenseadmin/family-delete-progress/" token)
                                                 (api/ajaxp (str "/licenseadmin/group/" family-id "/delete-preview/?progress_token=" token) {:disable-loadin-counter true})))
                                       (p/then (fn [data]
                                                 (ctrl/transact ctrl #(reset! state* {:stage :preview :data data})))))))
    :show-confirm (ctrl/transact ctrl #(swap! state* assoc :stage :confirm))
    :delete (do 
              (ctrl/transact ctrl #(swap! state* assoc :stage :deleting))
              (process-error errors
                             (-> (api/ajaxp (str "/licenseadmin/group/" family-id "/delete-progress-token/") {:disable-loadin-counter true})
                                 (p/then (fn [{:keys [token]}]
                                           (progressbar/start-progress-listener "/licenseadmin/family-delete-progress/" token)
                                           (api/ajaxp (str "/licenseadmin/group/" family-id "/delete/?progress_token=" token) {:disable-loadin-counter true})))
                                 (p/then (fn [_]
                                           (ctrl/transact ctrl #(reset! state* nil))
                                           (some-> on-success (apply [])))))))
    :clear (ctrl/transact ctrl #(reset! state* nil))
    nil))